<template>
    <div class="__chat" :class="{ __collapse: isCollapsed }">
        <div class="__title" @click="$emit('toggle-collapse')">
            <label>Message</label>
            <button class="new-conversation-btn" @click.stop="$emit('new-conversation')">
                New conversation
                <img src="@/assets/icons/new_conversation.svg" />
            </button>
        </div>
        <div class="__title-search" v-if="showSearch">
            <div class="search-widget">
                <img src="@/assets/icons/back_search.svg" alt width="20" />
                <input class="input-search" v-model="searchQuery" placeholder="Search contact" id="input-search" />
            </div>
        </div>
        <div class="search-results" v-if="newConnections.length > 0 && searchQuery">
            <div class="search-container">
                <div class="__item-chat" v-for="(chat, index) in newConnections" :key="index + 'chaths'"
                    @click="$emit('add-chat', chat); searchQuery = ''">
                    <div class="chat-content">
                        <img v-if="chat.profile_picture" :src="$fullUrl('images/profiles/' + chat.profile_picture)" />
                        <img v-else src="@/assets/avatar.png" alt />
                        <div class="__text">
                            <span class="_2">{{ (chat.first_name + " " + chat.last_name) | validate }}</span>
                        </div>
                    </div>
                    <div class="online" v-show="chat.is_online"></div>
                </div>
            </div>
        </div>
        <div class="__body" v-else-if="chatConnections.length !== 0">
            <div class="__item-chat" v-for="(chat, index) in chatConnections" :key="index + 'jsss'"
                @click="$emit('add-chat', chat)">
                <div style="display: flex">
                    <img v-if="chat.profile_picture" :src="$fullUrl('images/profiles/' + chat.profile_picture)" />
                    <img v-else src="@/assets/avatar.png" alt />
                    <div class="__text">
                        <span class="__tite">{{ (chat.first_name + " " + chat.last_name) | validate }}</span>
                        <span class="_2" v-linkified>{{ chat.message | validate }}</span>
                    </div>
                </div>
                <div class="online" v-show="chat.is_online"></div>
            </div>
        </div>
        <div v-else class="no-conversation-widget">
            <img src="@/assets/images/logo/logo__dark.svg" />
            <p>Get in touch with different consultants and customers.</p>
            <button @click.prevent="$emit('new-conversation')" class="new-conv">
                Start conversation
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatList',
    props: {
        isCollapsed: {
            type: Boolean,
            default: false
        },
        showSearch: {
            type: Boolean,
            default: false
        },
        chatConnections: {
            type: Array,
            default: () => []
        },
        newConnections: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            searchQuery: ''
        }
    },
    watch: {
        searchQuery(val) {
            this.$emit('search', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.__chat {
    height: 55px;
    z-index: 999999999 !important;
    border-top-left-radius: 10px;
    width: 300px;
    overflow: hidden;
    border-top-right-radius: 10px;
    box-shadow: 0px 0px 9px #ccc;
    transition: 500ms ease-in-out;

    &.__collapse {
        height: 550px;
        transition: 500ms ease-in-out;
    }

    .__title {
        padding: 10px;
        height: 55px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border: none;
        background: transparent linear-gradient(99deg, #1ba5a4 0%, #1ba5a4 21%, #1885ad 100%) 0% 0% no-repeat padding-box;
        border-radius: 5px 5px 0px 0px;

        label {
            color: #fff;
            font-weight: 800;
            font-size: 12px;
        }

        .new-conversation-btn {
            color: #fff;
            display: flex;
            align-items: center;
            height: 51px;
            outline: none;
            font-size: 12px;

            img {
                margin-left: 7px;
                margin-top: -3px;
            }
        }
    }

    .__title-search {
        background: #fff;
        padding: 10px 10px;
        height: 61px;
        position: relative;

        .search-widget {
            display: flex;
            background: #f7f7f7;
            align-items: center;
            justify-content: space-between;
            padding: 3px 9px;
            border-radius: 5px;
            width: 100%;

            img {
                width: 16px;
            }

            .input-search {
                border-radius: 5px;
                outline: none;
                width: 100%;
                background-position: 10px 13px;
                background-size: 15px 15px;
                padding: 10px 13px;
                border: none;
                font-size: 14px;
            }
        }
    }

    .search-results {
        padding: 10px;
        background: #fff;
        height: calc(100% - 111px);
        display: flex;
        justify-content: space-between;

        .search-container {
            background: #f7f7f7;
            border-radius: 5px;
            padding: 10px;
            overflow-y: auto;
            height: 100%;
            width: 100%;

            .__item-chat {
                padding: 8px 10px;
                cursor: pointer;

                .chat-content {
                    display: flex;
                    align-items: center;

                    img {
                        width: 40px;
                        height: 40px;
                        object-fit: cover;
                        border-radius: 50%;
                        margin-right: 10px;
                    }
                }

                &:hover {
                    background: #fff;
                    border-radius: 5px;
                    transition: 500ms ease-in-out;
                }
            }
        }
    }

    .__body {
        background: #fff;
        height: calc(100% - 55px);
        cursor: pointer;
        width: 100%;
        overflow-y: auto;

        .__item-chat {
            display: flex;
            background: transparent;
            flex-direction: row;
            cursor: pointer;
            justify-content: space-between;
            padding: 10px 10px;

            img {
                width: 35px;
                border-radius: 100px;
                height: 35px;
            }

            .__text {
                display: flex;
                text-align: left;
                flex-direction: column;
                margin-left: 10px;

                .__tite {
                    text-align: left;
                    font-size: 15px;
                    width: 220px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-weight: bold;
                    color: #808080;
                }

                ._2 {
                    color: #b3b3b3;
                    width: 220px;
                    font-weight: normal;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-size: 13px;
                    margin-top: -3px;
                }
            }

            .online {
                width: 10px;
                height: 10px;
                border-radius: 100px;
                background: #42b72a;
                margin-top: 10px;
            }
        }
    }

    .no-conversation-widget {
        background: #fff;
        height: calc(100% - 111px);
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-top: 60px;

        img {
            width: 100px;
            margin-bottom: 40px;
        }

        p {
            text-align: center;
            margin-bottom: 40px;
            font-weight: 300;
            color: #999999;
        }

        .new-conv {
            width: 218px;
            height: 40px;
            background: #00a5a6;
            border-radius: 5px;
            color: #fff;
        }
    }
}
</style>